import { useMemo, useState } from 'react';

import { PopoverPosition } from '@mui/material';

export interface IContextMenu {
  onContextMenu: (event: React.MouseEvent) => void,
  deactivate: () => void
}

export const useContextMenu = (props?: { isFetching?: boolean; isError?: boolean }): [PopoverPosition | undefined, IContextMenu] => {
  const { isFetching, isError } = props || {};
  const [anchorPosition, setAnchorPosition] = useState<PopoverPosition | undefined>();

  const context = useMemo(() => {
    const onContextMenu = (e: React.MouseEvent) => {
      e.preventDefault();
      const { clientX, clientY } = e;
      if (!isFetching && !isError) {
        setAnchorPosition((prev) => {
          if (prev) {
            return undefined;
          }
          return {
            top: clientY,
            left: clientX,
          };
        });
      }
    };

    const deactivate = () => {
      setAnchorPosition(undefined);
    };
    return { onContextMenu, deactivate }
  }, [isError, isFetching]);

  return [anchorPosition, context];
}
